import React, { useEffect } from 'react';
import NoDataComponent from '../../../dashboard/no_data_component.jsx';
import LoadingIndicator from '../../../common/loading_indicator.jsx';
import { useSelector } from 'react-redux';
import PhaseSelector from '../../../monitoring_report/edit/PhaseSelector.jsx';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchJson } from '../../../../helpers';

import {
    monitoring_report_status_dashboard_report_phase_data_path
} from '~/routes';

// TODO: Currently there's no way to live update when the tickbox e.g all_submission change. Because it's a GET request and the data is read from database currently.
// Can change to POST to have request body, even though the purpose is just GET
function WorkflowStatusWidget({ widgetId }) {
    const queryClient = useQueryClient();
    const projectId = useSelector(state => state.dashboard.projectId);
    const dashboardId = useSelector(state => state.dashboard.dashboardId);
    const workflowId = useSelector(state => state.dashboard.widgets[widgetId].settings?.workflow_id);
    const settings  = useSelector(state => state.dashboard.widgets[widgetId].settings);
    const {data, isLoading: loading} = useQuery({
        queryKey: ['mrs_dashboard_report_phase_data', workflowId, projectId, dashboardId, widgetId],
        queryFn: async () => {
            const url = monitoring_report_status_dashboard_report_phase_data_path({
                report_id: workflowId,
                project_id: projectId,
                dashboard_id: dashboardId,
                widget_id: widgetId,
            });
            return await fetchJson(url, {method: 'POST', body: JSON.stringify({widget_settings: {settings}})})
        },
        enabled: !!workflowId && !!projectId && !!dashboardId && !!widgetId
    })
    const show_days_passed = useSelector(state => state.dashboard.widgets[widgetId].settings?.show_days_passed);
    const all_submissions = useSelector(state => state.dashboard.widgets[widgetId].settings?.all_submissions);
    const assigned_workflows = useSelector(state => state.dashboard.widgets[widgetId].settings?.assigned_workflows);
    const own_projects = useSelector(state => state.dashboard.widgets[widgetId].settings?.own_projects);

    useEffect(() => {
        queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === 'mrs_dashboard_report_phase_data' && query.queryKey.at(-1) === widgetId});
    }, [all_submissions, assigned_workflows, own_projects, workflowId])

    return !loading ? (
        (data?.data || []).length==0 ? (
          <NoDataComponent />
        ) : (
            <div className="workflow-status-widget">
                <PhaseSelector
                    phaseData={{data: data?.data}}
                    onSelect= {()=>{}}
                    dispatch = {{}}
                    reportId = {workflowId}
                    options = {{
                        isWidget: true,
                        workflowSummary: data?.workflow_summary,
                        showDaysPassed: show_days_passed
                    }}
                />
            </div>
            )
      ) : (
        <LoadingIndicator />
      );
}

export default WorkflowStatusWidget;
